<script>
export default {
  name: "InfoRow",
  props: {
    left: {
      type: String,
      require: true
    },
    right: {
      type: String,
      require: true
    }
  }
};
</script>

<template>
  <div class="info-row">
    <div class="info-row-left">{{left}}</div>
    <div class="info-row-right">{{ right }}</div>
  </div>
</template>

<style scoped lang="less">
.info-row {
  width: 100%;
  display: flex;
  margin-top: 16px;

  .info-row-left {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }

  .info-row-right {
    margin-left: auto;
    font-size: 16px;
    font-weight: 400;
    color: #555555;
  }
}
</style>
